import { render, staticRenderFns } from "./Ruta.vue?vue&type=template&id=ade8aa7c"
import script from "./Ruta.vue?vue&type=script&lang=js"
export * from "./Ruta.vue?vue&type=script&lang=js"
import style0 from "./Ruta.vue?vue&type=style&index=0&id=ade8aa7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports